<template>
  <div v-if="profile">
    <vs-popup
      background-color-popup="#fff"
      class="agreementPopup"
      :active.sync="popupShow"
    >
      <div style="position: relative">
        <div
          style="max-height: 500px; overflow: auto"
          @scroll="onScroll"
          id="legalDocument"
          v-html="documentHtml"
        ></div>
        <div
          class="popup-scroll-fade"
          :style="{ 'background-color': '#fff' }"
          v-if="!scrolledToBottom"
        ></div>
        <div class="popup-scroll-fade-btn" v-if="!scrolledToBottom">
          <button @click="autoScroll()" class="">
            <img src="@/assets/images/arrow_down_btn.png" />
          </button>
        </div>
      </div>
      <button @click="popupShow = false" style="" class="btn-popup-close">
        <img src="@/assets/images/cancel_btn.png" />
      </button>

      <!-- <p class="text-sm text-gray-500">
                        Lorem ipsum dolor sit amet.
                      </p>-->

      <div class="flex justify-center mt-10">
        <p
          style="  text-gray-700
            font-medium
            text-sm
            hover:bg-blue-200
            "
        >
          Accepted {{ documentDate }}
        </p>
      </div>
      <!-- <div class="flex justify-center mt-6">
        <button
          @click="popupShow = false"
          :disabled="!scrolledToBottom"
          style="position: relative"
          class="btn-cot"
          :style="!scrolledToBottom ? 'opacity: 0.5; cursor: default' : ''"
        >
          Accept
          <div style="display: inline; position: absolute; right: 1rem">
            <ArrowNarrowRightIcon class="h-5 w-5" />
          </div>
        </button>
      </div>
      <div class="flex justify-center mt-4">
        <a
          style=""
          class="
            text-gray-700
            font-medium
            text-sm
            hover:bg-blue-200
            cursor-pointer
          "
          @click="closeModal(false)"
          >Cancel</a
        >
      </div>-->
    </vs-popup>
    <vx-card no-shadow>
      <div class="vx-row mb-6 mt-2">
        <div class="vx-col sm:w-2/5 w-full">
          <h4 class="mb-4">Venue consents</h4>
          <p>
            Consent by type and venue can be toggled off by clicking "Yes" or
            "No" in the table.
          </p>
        </div>
      </div>

      <vs-table :data="userConsent">
        <template slot="header"> </template>
        <template slot="thead">
          <vs-th> Venue </vs-th>
          <vs-th v-for="(type, idx) in consentNames" :key="idx">{{
            type
          }}</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].name">
              {{ data[indextr].name }}
            </vs-td>

            <vs-td v-for="(type, idx) in consentTypes" :key="idx">
              <div
                @click="
                  toggleConsent(
                    data[indextr].consents.includes(type),
                    type,
                    data[indextr].venueId
                  )
                "
                class="cursor-pointer"
              >
                <vs-chip
                  :color="data[indextr].consents.includes(type) | yesnocolor"
                >
                  {{ data[indextr].consents.includes(type) | yesno }}
                </vs-chip>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <!-- Save & Remove Button -->
      <!--<vs-row
        vs-justify="space-between"
        class="flex flex-wrap items-center"
        style="margin-top: 32px"
      >
        <vs-button
          id="remove-button"
          @click="removeProfile"
          color="danger"
          class="mt-2"
          >Remove</vs-button
        >
        <vs-button id="save-button" @click="updateProfile" class="mt-2"
          >Save Changes</vs-button
        >
      </vs-row>-->
    </vx-card>

    <vx-card class="mt-6" no-shadow>
      <div class="vx-row mb-6 mt-2">
        <div class="vx-col sm:w-2/5 w-full">
          <h4 class="mb-4">Agreements</h4>
          <p>
            These are the documents that the guest has given consent to. Venue
            consent is often based on these documents.
          </p>
          <h4 v-for="(v, idx) in agreementVenues" :key="idx" class="mt-4">
            {{ venueName(v) }}

            <vs-row class="mt-2">
              <vs-button
                v-for="(d, idx) in agreements[v]"
                :key="idx"
                @click="
                  reviewDocument(v, d.legalDocumentId, d.revision, d.timestamp)
                "
                type="relief"
                icon="description"
                style="margin-right: 0.4rem"
              ></vs-button
            ></vs-row>
          </h4>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  components: {},

  data() {
    return {
      // eslint-disable-next-line
      _,

      scrolledToBottom: false,
      moment,
      popupShow: false,
      documentHtml: "",
      documentDate: "",
      agreementVenues: [],
      agreements: {},
      profile: null,
      profileId: "",
      userConsent: null,
      apiConfig: {
        legalDocumentUrl: (venueid, docid, revision) =>
          `https://rekom-crm-functions-prod.azurewebsites.net/api/DynamicFormsGetLegalDocument?venueid=${venueid}&docid=${docid}&revision=${revision}`,
      },
    };
  },
  computed: {
    ...mapGetters({
      venues: "venues/venues",
      consentTypes: "guestProfiles/consentTypes",
      consentNames: "guestProfiles/consentNames",
    }),

    venueConsentMapped() {
      return this.profile.firstName + " " + this.profile.lastName;
    },
  },
  methods: {
    autoScroll() {
      const objDiv = document.getElementById("legalDocument");
      objDiv.scrollTop = objDiv.scrollHeight;
    },
    onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (scrollTop + clientHeight >= scrollHeight) {
        this.scrolledToBottom = true;
      } else {
        //this.scrolledToBottom = false;
      }
    },
    venueName(id) {
      const venue = this.venues.find((e) => e.venueId === id);
      return venue ? venue.name : "Unknown venue";
    },
    async reviewDocument(venueId, id, revision, acceptDate) {
      this.$vs.loading();
      const url = this.apiConfig.legalDocumentUrl(venueId, id, revision);
      const result = await fetch(url);
      const json = await result.json();
      this.documentHtml = json.doc.documentHtml;
      this.documentDate = moment(acceptDate).format("DD/MM/YYYY HH:mm");
      this.$vs.loading.close();
      this.popupShow = true;
    },
    /*async toggleConsent(removeConsent, consentType, venueId) {
      if (!this.$AuthService.hasPermission('vp.crm.guestprofiles.edit')) return;
      this.$vs.loading();
      console.log(removeConsent, consentType, venueId, this.profile.id);
      if (removeConsent) {
        await this.$store.dispatch("guestProfiles/removeVenueConsent", {
          guestId: this.profileId,
          venueId: venueId,
          consent: consentType,
        });
      } else {
        await this.$store.dispatch("guestProfiles/addVenueConsent", {
          guestId: this.profileId,
          venueId: venueId,
          consent: consentType,
        });
      }
      this.profile = this.$store.getters["guestProfiles/profile"](
        this.profileId
      );
      await this.processConsent();
      this.$vs.loading.close();
    },*/
    async toggleConsent(removeConsent, consentType, venueId) {
      // 03/05/2022 change: GR can only add consent
      if (!this.$AuthService.hasPermission("vp.crm.guestprofiles.edit")) return;
      if (
        !this.$AuthService.hasPermission("vp.crm.guestprofiles.addConsent") &&
        !removeConsent
      )
        return;
      this.$vs.loading();
      console.log(removeConsent, consentType, venueId, this.profile.id);
      if (removeConsent) {
        await this.$store.dispatch("guestProfiles/removeVenueConsent", {
          guestId: this.profileId,
          venueId: venueId,
          consent: consentType,
        });
      } else {
        await this.$store.dispatch("guestProfiles/addVenueConsent", {
          guestId: this.profileId,
          venueId: venueId,
          consent: consentType,
        });
      }
      this.profile = this.$store.getters["guestProfiles/profile"](
        this.profileId
      );
      await this.processConsent();
      this.$vs.loading.close();
    },
    async processConsent() {
      const venuesConsent = this.venues.filter(
        (e) => this.profile.venueConsents[e.venueId]
      );
      this.userConsent = venuesConsent.map((e) => {
        const consentsOrNull = this.profile.venueConsents[e.venueId];
        const venueConsents = consentsOrNull ? consentsOrNull.consents : [];
        return { consents: venueConsents, ...e };
      });
    },
    async processAgreements() {
      console.log(this.profile.agreements);
      const agg = Object.keys(this.profile.agreements);
      agg.forEach((e) => {
        const [venueId, docId] = e.split(":");
        if (!this.agreementVenues.includes(venueId))
          this.agreementVenues.push(venueId);
        if (this.agreements[venueId]) {
          this.agreements[venueId].push(...this.profile.agreements[e]);
        } else {
          this.agreements[venueId] = [...this.profile.agreements[e]];
        }
      });
    },
  },
  async created() {
    this.profileId = this.$route.params.id;
    await this.$store.dispatch("guestProfiles/getGuest", this.profileId, false);
    this.profile = this.$store.getters["guestProfiles/profile"](this.profileId);

    await this.processConsent();
    await this.processAgreements();
    console.log(this.profile);
  },
};
</script>

<style lang="scss">
.agreementPopup {
  .vs-popup--header {
    display: none;
  }
  .agreementPopup .vs-popup--header {
    display: none;
  }

  .con-vs-popup .vs-popup {
    max-width: 36rem;
    max-height: 50rem;
  }

  .vs-popup--header {
    display: none;
  }

  .vs-popup--content {
    padding-top: 3.5rem !important;
    padding-right: 3.5rem !important;
    padding-left: 3.5rem !important;
  }

  .htmlDiv {
    overflow: auto;
  }

  .bg-black-opacity {
    background-color: rgba(0, 0, 0, 0.55);
  }
  ::-webkit-scrollbar {
    width: 0; /* Remove scrollbar space */
    background: transparent; /* Optional: just make scrollbar invisible */
  }
  /* Optional: show position indicator in red */
  ::-webkit-scrollbar-thumb {
    background: #ff0000;
  }
  .btn-popup-close {
    top: 1.5rem;
    right: 1.5rem;
    position: absolute;
    background-color: transparent;
    border: none;
  }
  .btn-popup-close img {
    object-fit: cover;
    height: 30px;
    width: auto;
  }

  .popup-scroll-fade {
    width: 100%;
    height: 80px;
    bottom: 0;
    left: 0;
    overflow: hidden;
    position: absolute;

    -webkit-mask-image: -webkit-gradient(
      linear,
      left bottom,
      left top,
      from(rgba(0, 0, 0, 1)),
      to(rgba(0, 0, 0, 0))
    );
  }
  .popup-scroll-fade-btn {
    width: 50px;
    height: 50px;
    bottom: 0;
    margin-left: -25px;
    left: 50%;
    position: absolute;
  }
  .popup-scroll-fade-btn img {
    width: 50px;
    height: 50px;
    background-color: transparent;
  }
  .popup-scroll-fade-btn button {
    background-color: transparent;
    border: none;
  }

  .btn-cot:disabled {
    --tw-bg-opacity: 1;
    background-color: rgba(100, 106, 124, var(--tw-bg-opacity));
  }

  .btn-cot {
    border: none;
    --tw-text-opacity: 1;
    color: rgba(255, 255, 255, var(--tw-text-opacity));
    font-size: 0.875rem;
    line-height: 1.25rem;
    --tw-bg-opacity: 1;
    background-color: rgba(0, 0, 0, var(--tw-bg-opacity));
    border-radius: 9999px;
    padding-top: 1.625rem;
    padding-bottom: 1.625rem;
    padding-left: 4rem;
    padding-right: 4rem;
    font-size: 1.125rem;
  }

  .text-sm {
    font-size: 0.875rem !important;
  }

  .font-medium {
    font-weight: 500 !important;
  }
}
</style>